// extracted by mini-css-extract-plugin
export default {"archive__backBtn":"document-templates-archive_archive__backBtn__bmiIN","archive__table":"document-templates-archive_archive__table__XHaJY"};